export const INDUSTRY_OPTIONS = [
  { value: 'technology', label: 'Technology' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'finance', label: 'Finance' },
  { value: 'education', label: 'Education' },
  { value: 'sales', label: 'Sales' },
  { value: 'operations', label: 'Operations' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'legal', label: 'Legal' },
];

const INDUSTRY_RULES = {
  technology: [
    'software',
    'developer',
    'engineer',
    'devops',
    'cloud',
    'data',
    'cyber',
    'qa',
    'it ',
    'machine learning',
    'ai ',
  ],
  healthcare: [
    'nurse',
    'physician',
    'doctor',
    'medical',
    'clinic',
    'hospital',
    'therap',
    'pharmac',
    'patient',
  ],
  finance: ['finance', 'financial', 'accountant', 'accounting', 'audit', 'tax', 'bank'],
  education: ['teacher', 'professor', 'instructor', 'education', 'faculty', 'school', 'tutor'],
  sales: ['sales', 'account executive', 'business development', 'customer success', 'territory manager'],
  operations: ['operations', 'logistics', 'warehouse', 'supply chain', 'maintenance', 'technician', 'production'],
  marketing: ['marketing', 'seo', 'content', 'brand', 'social media'],
  legal: ['legal', 'attorney', 'lawyer', 'counsel', 'paralegal', 'compliance'],
};

const normalized = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

export const classifyIndustry = (jobTitle = '', standardJobTitle = '') => {
  const text = normalized(`${standardJobTitle || ''} ${jobTitle || ''}`);
  if (!text) return 'unknown';

  for (const industry of Object.keys(INDUSTRY_RULES)) {
    const keywords = INDUSTRY_RULES[industry];
    if (keywords.some((keyword) => text.includes(keyword))) return industry;
  }

  return 'unknown';
};

export const normalizeIndustryValue = (value) => {
  const key = normalized(value);
  return INDUSTRY_OPTIONS.some((option) => option.value === key) ? key : '';
};
